export const ONE_DRIVE_CONSUMER_TOKEN_SCOPE = 'onedrive_implicit.access';

export const BEARER_TOKEN_HEADER_PREFIX = 'Bearer ';
